import { Component } from '@angular/core';
import {
   Router,
   NavigationStart,
} from '@angular/router';

import { startWith } from 'rxjs/operators';

import { environment } from './http';

import { BrandingService, ThemeService } from '@library/common/branding';
import {
   BreakpointService,
   BrowserCheckService,
   EnvironmentService,
   ErrorMessageService,
   GoogleAnalyticsService,
   PrefetchService,
   TextService,
   MaintenanceService,
   PortalService,
} from '@library/core/services';

import { AppConfigService } from '@library/app.config';

import * as FullStory from '@fullstory/browser';

@Component({
   selector: 'app-root',
   template: `<router-outlet></router-outlet>`,
})
export class AppComponent {
   constructor(
      private error: ErrorMessageService,
      private e: EnvironmentService,
      private gtag: GoogleAnalyticsService,
      private theme: ThemeService,
      private check: BrowserCheckService,
      private breakpoints: BreakpointService,
      private text: TextService,
      private prefetch: PrefetchService,
      private maintenance: MaintenanceService,
      private appConfig: AppConfigService,
      private portalService: PortalService,

      public router: Router,
      public brand: BrandingService,
   ) {
      this.portalService.current = '4pl';

      this.e.environment = environment;
      this.gtag.load( environment?.gtagId );
      this.breakpoints.tap();
      this.check.check();
      this.maintenance.check();
      FullStory.init({ orgId: 'o-1MB0F2-na1', devMode: !environment.production });

      // console.log( 'requesting server', this.server );

      // switch on account
      // this.appConfig.load( 'hawaiianair' );
      this.theme.themeChange$.pipe(
         startWith( this.theme.themeChange$.getValue() ),
      ).subscribe( theme => this.appConfig.load( theme.class ));

      this.text.loginTitle = `Ship and Track with Our 4PL Portal`;
      this.text.loginSubTitle = `Designed to bring business value to you,
         Our 4PL Portal will provide access to vital information on all your shipments.
         Log in today to book or track your freight.`;

      this.prefetch.items = [
         'servicelevels',
         'currencies',
         'countries',
      ];

      const whitelist = [
         '/error',
         '/termsagree',
      ];

      this.router.events.subscribe( event => {
         if ( event instanceof NavigationStart && !whitelist.includes( event.url )) {
            this.error.resetErrors();
         }
      });
   }
}
